import { render, staticRenderFns } from "./uploda-file-modal.vue?vue&type=template&id=083ceaf8&scoped=true&"
import script from "./uploda-file-modal.vue?vue&type=script&lang=ts&"
export * from "./uploda-file-modal.vue?vue&type=script&lang=ts&"
import style0 from "./uploda-file-modal.vue?vue&type=style&index=0&id=083ceaf8&prod&lang=less&scoped=true&"
import style1 from "./uploda-file-modal.vue?vue&type=style&index=1&id=083ceaf8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083ceaf8",
  null
  
)

export default component.exports